import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';
import { GetCommertialsConditionsResponse } from '../../../../../../../../../shared/interfaces';
import { FirePaymentMethodForm, FireQuotationForm } from './StepFourFormProvider';

import { FireQuotationComponent, FireQuotationRequest, WebFireQuotation } from '../../../../../../../../../shared/interfaces/services/fire-quotation-service';
import { QuotationButton } from '../../../../../shared';

interface StepFourFormContextProps {
  stepFourFireQuotationForm:      FormInstance<FireQuotationForm>; //TODO: Agregar Interface

  firePaymentMethodsForm:          FormInstance<FirePaymentMethodForm>;

  labelButton:                    QuotationButton;
  setLabelButton:                 Dispatch<SetStateAction<QuotationButton>>;

  quotationResponse?:             WebFireQuotation | undefined;
  setQuotationResponse:           Dispatch<SetStateAction<WebFireQuotation | undefined>>;

  fireQuotationComponents:         Array<FireQuotationComponent>;

  commertialConditions:           GetCommertialsConditionsResponse | undefined;

  generateFireQuotationForm:      () => FireQuotationRequest;

  clearPrimaFieldsOnFormChange:   () => void;
  
  quotationTabs:                  Array<any>;
  setQuotationTabs:               Dispatch<SetStateAction<Array<any>>>;
  
  activeTab:                      any;
  setActiveTab:                   Dispatch<SetStateAction<any>>;

  createTabs:                     () => void;
  
  handlerOnClick:                 () => Promise<void>;
}

export const StepFourFormContext = createContext(
  {} as StepFourFormContextProps
);
